import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Order as OrderModel } from 'msp-integrations'
import { CustomLinkComponent } from 'msp-components'

const translations = defineMessages({
  DHL: {
    defaultMessage: 'DHL Tracking-ID:',
    id: 'msp.account.order_history.order_status.tracking.dhl'
  }
})

type OrderTrackingProps = {
  order: OrderModel
  className?: string
}

// @TODO this should be provided from the SFCC
const OrderTracking = ({ order, className = '' }: OrderTrackingProps) => {
  const { formatMessage } = useIntl()
  const shipment = order?.getShipment()

  return (
    <>
      {shipment && shipment.trackingNumber && (
        <div
          className={`font-Roboto leading-12 text-14 flex w-full flex-row items-center text-black ${className}`}
        >
          <span>{formatMessage(translations.DHL)}</span>
          <CustomLinkComponent
            href={order.c_trackingLink}
            className={`hover:text-mediumGray pl-2 underline transition duration-200 ease-in`}
            isExternalLink
            openInNewTab
            inline
          >
            {shipment.trackingNumber}
          </CustomLinkComponent>
        </div>
      )}
    </>
  )
}

export default OrderTracking
